import sbjs from 'sourcebuster'
import { logger } from '@/utils/logger'
import { SOCIAL_MEDIUM } from '@/utils/linkedinAttribution'

// Untagged LinkedIn clicks are organic; li_fat_id or campaign params are what make one paid
export const SOURCEBUSTER_REFERRALS = [
  { host: 'linkedin.com', medium: SOCIAL_MEDIUM, display: 'linkedin' },
  { host: 'lnkd.in', medium: SOCIAL_MEDIUM, display: 'linkedin' },
]

export const SOURCEBUSTER_OPTIONS = {
  lifetime: 12,
  referrals: SOURCEBUSTER_REFERRALS,
}

// Sourcebuster classifies a visit on the first init of a session, so every caller must pass the same options
export function initSourcebuster(): void {
  if (typeof document === 'undefined') return
  try {
    sbjs.init(SOURCEBUSTER_OPTIONS)
  } catch (error) {
    logger.warn('[Sourcebuster] init failed', { error: error instanceof Error ? error.message : String(error) })
  }
}
